import { BrowserRouter } from "react-router-dom";
import Shell from "@/layout/Shell.jsx";
import Modals from "@/layout/Modals.jsx";
import AppRoutes from "@/routes/AppRoutes.jsx";
import ErrorBoundary from "@/shared/components/ErrorBoundary.jsx";
import { useAppBootstrap } from "@/shared/store/useAppBootstrap.js";

function AppShell() {
  useAppBootstrap();
  return (
    <Shell>
      <AppRoutes />
      <Modals />
    </Shell>
  );
}

export default function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <AppShell />
      </BrowserRouter>
    </ErrorBoundary>
  );
}
